import { Box, Heading, Text,VStack, Icon } from '@chakra-ui/react'
import { AlertTriangle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
export const NotFound = () => {
  const navigate = useNavigate()
  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.900"
      p={4}
    >
      <VStack spacing={8} maxW="400px" textAlign="center">
        <Icon as={AlertTriangle} boxSize={16} color="#ff3d00" />
        <VStack spacing={3}>
          <Heading size="2xl" color="white">
            404
          </Heading>
          <Heading size="md" color="gray.300" fontWeight="normal">
            Page Not Found
          </Heading>
        </VStack>
        <Text color="gray.400">
          The page you're looking for doesn't exist or has been moved.
        </Text>
   
      </VStack>
    </Box>
  )
}
